<script lang="ts">
  import { navigate } from 'svelte-routing';
</script>

<svelte:head>
  <title>Unsubscribed - outlive.it</title>
</svelte:head>

<section id="main" class="main">
  <header>
    <h2>Successfully Unsubscribed</h2>
  </header>

  <p>
    Your email address has been removed from our records.
  </p>
  <p>
    You will no longer receive progress notifications.
  </p>
  <p>
    Thank you for playing Outlive!
  </p>
  <p>
    <a href="/" class="button" on:click|preventDefault={() => navigate('/')}>Return to home</a>
  </p>
</section>

<style>
  #main {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }

  #main > header:first-child {
    text-align: center;
  }

  @media screen and (max-width: 736px) {
    #main {
      padding: 2em;
    }
  }
</style>
